import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormattedPrice, Loading, useTranslations } from "@jti/ui";
import { useFreeTrial } from "../../../../hooks/useFreeTrial";
import { useOrder } from "../../../../hooks/useOrder";
import useTotal from "../../../../hooks/useTotal";
import styles from "./PaymentPageTotalPrice.module.scss";
export const PaymentPageTotalPrice = () => {
    const { __ } = useTranslations();
    const { isFreeTrial } = useFreeTrial();
    const { order, orderFetchStatus } = useOrder();
    const { shopCurrency, totalPrice } = useTotal(isFreeTrial, !order, order);
    const currency = shopCurrency?.code;
    const isPriceAvailable = currency && typeof totalPrice === "number" && totalPrice > -1;
    return (_jsxs("div", { className: styles.total, "data-testid": "total-price", children: [_jsx("div", { className: styles.totalTitle, children: __("cart.prices.total.title") }), orderFetchStatus === "pending" ? (_jsx(Loading, {})) : (_jsx("div", { className: styles.totalValue, "data-testid": "total-price-value", children: isPriceAvailable ? _jsx(FormattedPrice, { currency: currency, value: totalPrice }) : __("cart.prices.na") }))] }));
};
//# sourceMappingURL=PaymentPageTotalPrice.js.map